import { PROJECT } from "../actions/types";

const initialState = {
  getProjects: {
    projects: {},
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getProject: {
    project: {},
    errorMessage: null,
    isFetching: false,
  },

  deleteProject: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getScheduleOfProject: {
    schedule: [],
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region PROJECT.GET_PROJECTS

    case PROJECT.PROJECT_GET_PROJECTS_REQUEST:
      return {
        ...state,
        getProjects: {
          projects: {},
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case PROJECT.PROJECT_GET_PROJECTS_SUCCESS:
      return {
        ...state,
        getProjects: {
          projects: action.payload,
          successMessage: "Projecten succesvol opgehaald.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case PROJECT.PROJECT_GET_PROJECTS_FAIL:
      return {
        ...state,
        getProjects: {
          projects: {},
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region PROJECT.GET_PROJECT

    case PROJECT.PROJECT_GET_PROJECT_REQUEST:
      return {
        ...state,
        getProject: {
          project: {},
          errorMessage: null,
          isFetching: true,
        },
      };

    case PROJECT.PROJECT_GET_PROJECT_SUCCESS:
      return {
        ...state,
        getProject: {
          project: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case PROJECT.PROJECT_GET_PROJECT_FAIL:
      return {
        ...state,
        getProject: {
          project: {},
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region PROJECT.DELETE

    case PROJECT.PROJECT_DELETE_REQUEST:
      return {
        ...state,
        deleteProject: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case PROJECT.PROJECT_DELETE_SUCCESS:
      return {
        ...state,
        deleteProject: {
          successMessage: "Project verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case PROJECT.PROJECT_DELETE_FAIL:
      return {
        ...state,
        deleteProject: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region PROJECT.GET_SCHEDULE

    case PROJECT.PROJECT_GET_SCHEDULE_REQUEST:
      return {
        ...state,
        getScheduleOfProject: {
          schedule: [],
          errorMessage: null,
          isFetching: true,
        },
      };

    case PROJECT.PROJECT_GET_SCHEDULE_SUCCESS:
      return {
        ...state,
        getScheduleOfProject: {
          schedule: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case PROJECT.PROJECT_GET_SCHEDULE_FAIL:
      return {
        ...state,
        getScheduleOfProject: {
          schedule: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projectReducer.js